// extracted by mini-css-extract-plugin
export default {"container":"common_container__vaIXi","text":"common_text__PS5x3","actions":"common_actions__N8F4l","dropdown":"common_dropdown__8rj22"};